<template>
  <div class="p-3 border rounded bg-white">
    <div class="mb-3">
      <h5><strong>Vizualizare: Factura Fiscala</strong></h5>
      <div class="row">
        <div class="col-md-9">
          <table class="table table-bordered table-sm mb-3 bg-light">
            <thead>
              <tr class="table-success text-center">
                <th>Client</th>
                <th>Seria si nr. document</th>
                <th>Data emiterii</th>
                <th>Termen de plata</th>
                <th>Sold</th>
                <th>e-Factura</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <td class="text-start">{{ factura.c_denumire }}</td>
                <td>{{ factura.serie_doc }} {{ factura.nr_doc }}</td>
                <td>{{ this.formatDate(factura.data_doc) || '/' }}</td>
                <td>{{ this.formatDate(factura.data_scadenta) || '/' }}</td>
                <td>{{ formatCurrency(factura.isf_sold) || '0.00' }}</td>
                <td>{{ factura.efactura === 'Da' ? '<span class="badge bg-success">OK</span>' : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <table class="table table-bordered table-sm mb-3 bg-light">
      <thead>
        <tr class="table-success text-center">
          <th></th>
          <th>Tip</th>
          <th>Denumire articol / serviciu</th>
          <th>UM</th>
          <th>TVA %</th>
          <th>Cantitate</th>
          <th>Pret unitar</th>
          <th>Valoare</th>
          <th>TVA</th>
          <th>Total</th>
          <th>Cont credit</th>
        </tr>
      </thead>
      <tbody>
        <tr class="text-center" v-for="(prod, index) in produse" :key="index">
          <td>{{ prod.pozitie || '' }}</td>
          <td>
            <b>{{ prod.tp_abreviere_tip_produs }}</b> <small class="text-muted">({{ prod.tp_text }})</small>
          </td>
          <td class="text-start">{{ prod.denumire || '' }}</td>
          <td>{{ prod.unitate_masura || '' }}</td>
          <td>{{ prod.cota_tva || '' }}</td>
          <td>{{ prod.cantitate || '' }}</td>
          <td>{{ formatCurrency(prod.pret_unitar) || '0.00' }}</td>
          <td>{{ formatCurrency(prod.valoare) || '0.00' }}</td>
          <td>{{ formatCurrency(prod.tva) || '0.00' }}</td>
          <td>{{ formatCurrency(prod.total) || '0.00' }}</td>
          <td>{{ prod.cont_credit || '' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between align-items-start w-100">
      <div class="d-flex flex-column gap-2 mb-3">
        <table class="table table-bordered table-sm px-0 mx-0 bg-light" style="width: auto;">
          <thead>
            <tr class="table-success text-center">
              <th style="min-width: 250px;">Informatii suplimentare</th>
              <th style="min-width: 250px;">Descarcarea de gestiune</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-start">

              </td>
              <td>
                <div class="cls_DOCw_tabeliesiri3_row_0_col_1_ck_cant_g_F">
                  <i class="fa fa-exclamation-circle fa-lg" aria-hidden="true" style="color: #a94442;"></i>
                  &nbsp;&nbsp;<span style="color: #a94442;">
                    <strong>Fara descarcarea de gestiune.</strong>
                  </span>
                  Livrarea produselor si descarcarea gestiunii se fac pe baza Avizului de Insotire a Marfurilor
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- ACTION BUTTONS REMOVED - Moved to main table row -->
      </div>

      <div class="d-flex flex-column justify-content-center align-items-end me-4" style="min-width: 300px;">
        <div style="font-size: 1.2rem;"><strong>Total fara TVA:</strong> {{ formatCurrency(factura.intrari_date_valoare)
          || '0.00' }}</div>
        <div style="font-size: 1.2rem;"><strong>Total TVA:</strong> {{ formatCurrency(factura.intrari_date_tva) ||
          '0.00' }} </div>
        <hr class="w-100 my-2" />
        <div style="font-size: 1.5rem; font-weight: bold;"><strong>Total:</strong> {{
          formatCurrency(factura.intrari_date_total) || '0.00' }}</div>
      </div>
    </div>
    <!-- Inserted Delegat Table Here -->
    <table class="table table-bordered table-sm mb-3 bg-light w-75">
      <thead>
        <tr class="table-success text-center">
          <th>Delegat</th>
          <th>CNP/Buletin delegat</th>
          <th>Auto</th>
          <th>Curs Valutar</th>
          <th>Intocmit de</th>
          <th>CNP</th>
        </tr>
      </thead>
      <tbody>
        <tr class="text-center">
          <td>{{ factura.delegat || '-' }}</td>
          <td>{{ factura.delegat_cnp || '-' }}</td>
          <td>{{ factura.delegat_auto || '-' }}</td>
          <td>{{ factura.curs || '-' }}</td>
          <td>{{ factura.nume || '-' }}</td>
          <td>{{ factura.cnp || '-' }}</td>
        </tr>
      </tbody>
    </table>
    
    <!-- Istoric Plati -->
    <div v-if="history.length > 0" class="mt-4">
        <h6 class="text-primary mb-2"><i class="fas fa-history me-1"></i> <strong>Istoric Plăți:</strong></h6>
        <table class="table table-bordered table-sm mb-3 bg-white shadow-sm">
            <thead class="table-light">
                <tr class="text-center align-middle">
                    <th>Data</th>
                    <th>Tip Document</th>
                    <th>Nr. Document</th>
                    <th>Explicații</th>
                    <th class="text-end">Sumă Plătită</th>
                    <th style="width: 80px;">Acțiuni</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(h, idx) in history" :key="idx" class="text-center align-middle">
                    <td>{{ formatDate(h.data_plata) }}</td>
                    <td>
                      <span class="badge bg-secondary">{{ h.tip_document }}</span>
                    </td>
                    <td>{{ h.numar_document || '-' }}</td>
                    <td class="text-start small text-muted">{{ h.explicatii }}</td>
                    <td class="text-end fw-bold text-danger">{{ formatCurrency(h.suma_repartizata) }}</td>
                    <td>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-xs btn-outline-primary me-1 p-1 py-0" title="Editează" @click="handleEditPlata(h)">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="btn btn-xs btn-outline-danger p-1 py-0" title="Șterge" @click="handleDeletePlata(h)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                </tr>
            </tbody>
            <tfoot class="table-light fw-bold">
                <tr>
                    <td colspan="4" class="text-end">Total Plătit:</td>
                    <td class="text-end text-danger">{{ formatCurrency(totalPlatit) }}</td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>

  </div>
</template>

<script>


export default {
  props: {
    factura: Object,
    produse: Array,
    onEditPlata: Function,
    onDeletePlata: Function
  },
  data() {
    return {
      setari_select2: {
        theme: 'bootstrap-5',
        placeholder: "Selectează din listă",
        width: "100%",
      },
      unitati_masura: [],
      history: []
    }
  },
  computed: {
    totalPlatit() {
        return this.history.reduce((acc, h) => acc + (parseFloat(h.suma_repartizata) || 0), 0);
    }
  },
  watch: {
    'factura.id': {
        immediate: true,
        handler() {
            this.loadHistory();
        }
    }
  },
  methods: {
    async loadHistory() {
        if (!this.factura || !this.factura.id) return;
        try {
            const response = await axios.get(`/api/contabilitate/plati/history/${this.factura.id}`);
            this.history = response.data;
        } catch (e) {
            console.error("Eroare incarcare istoric plati", e);
        }
    },
    handleEditPlata(plata) {
        if (typeof this.onEditPlata === 'function') {
            this.onEditPlata(plata);
        }
    },
    handleDeletePlata(plata) {
        if (typeof this.onDeletePlata === 'function') {
            this.onDeletePlata(plata);
        }
    },
    formatDate(date) {
      if (!date) return '/';
      return new Date(date).toLocaleDateString('ro-RO');
    },
    formatCurrency(value) {
      if (value !== undefined && value !== null) {
        var formatter = new Intl.NumberFormat('ro-RO', {
          style: 'currency',
          currency: 'Lei',
          currencyDisplay: 'symbol',
        });
        return formatter.format(value);
      }
      return '0.00 Lei';
    },
    incarcaUnitatiMasura() {
      axios.get('/api/facturare/utils/incarcaUnitatiMasura')
        .then((response) => {
          this.unitati_masura = response.data;
        });
    },
  },
  created() {

    //this.incarcaUnitatiMasura();

  },
};
</script>